import React from 'react';
import moment from 'moment';
import { RouteProps } from 'react-router';
import { Link, useRouteMatch } from 'react-router-dom';
import styled, { css } from 'styled-components/macro';

import { faChevronLeft, faChevronRight } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

type Params = {
  startYear: number;
  basePath: string;
  routeMatch: RouteProps;
};

export const useYearLinks = ({ startYear, basePath, routeMatch }: Params) => {
  const currentYear = parseInt(moment().format('YYYY'), 10);

  const match = useRouteMatch<{ year?: string }>(routeMatch);
  const year = Number(match?.params?.year || currentYear);

  const disableBackwardLink = year === startYear;
  const disableForwardLink = year === currentYear;

  const nextYear = year + 1;

  const backLinkPath = `${basePath}/${year - 1}`;
  const forwardLinkPath = nextYear === currentYear ? basePath : `${basePath}/${nextYear}`;

  const backLink = (
    <PrevNextLink $disabled={disableBackwardLink} to={backLinkPath}>
      <FontAwesomeIcon size="sm" icon={faChevronLeft} />
    </PrevNextLink>
  );

  const forwardLink = (
    <PrevNextLink $disabled={disableForwardLink} to={forwardLinkPath}>
      <FontAwesomeIcon size="sm" icon={faChevronRight} />
    </PrevNextLink>
  );

  return {
    backLink,
    forwardLink,
    year,
  };
};

export const PrevNextLink = styled(Link)<{ $disabled: boolean }>`
  ${(props) =>
    props.$disabled &&
    css`
      opacity: 0.3;
      pointer-events: none;
    `}
`;
